<template>
    <div class="project-dose-wrappper">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <div class="select-item" @click="startTimePicker = true">
                    <span>{{ startTimeValue }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
                <p>—</p>
                <div class="select-item" @click="endTimePicker = true">
                    <span>{{ endTimeValue }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
            </div>
            <div class="statistics-head">
                <div class="month-count">
                    <span>{{ statistics.gczsl || 0 }}</span>
                    <p>工程总数量（个）</p>
                </div>
                <div class="year-count">
                    <span>{{ statistics.yyflzs || 0 }}</span>
                    <p>已用方量总数（方）</p>
                </div>
            </div>
        </div>
        <!-- <div class="top-wrapper">
            <div class="select-wrapper">
                <span
                    v-for="(item,index) in navData"
                    :key="index"
                    :class="{active: activeIndex === index}"
                    @click="toggle(index,item.type)"
                >{{ item.name }}</span>
            </div>
            <div class="chart-wrapper">
                <p>工程数量统计</p>
                <div id="myChart1" class="my-chart"></div>
            </div>
        </div> -->
        <div class="chart-wrapper">
            <p>工程数量统计</p>
            <div id="myChart1" class="my-chart"></div>
        </div>
        <div class="bottom-wrapper">
            <p>已用方量统计</p>
            <div id="myChart2" class="my-chart"></div>
        </div>
        <!-- 开始时间 -->
        <van-popup v-model="startTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup v-model="endTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="endCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_blue from '../../../assets/images/home/bg_blue.png';
import { Toast } from 'vant';
export default {
    data() {
        return {
            startTimeValue: '', // 开始时间text
            endTimeValue: '', // 结束时间text
            startTimePicker: false, // 开始时间弹出层
            endTimePicker: false, // 结束时间弹出层
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), // 开始时间默认日期
            endCurrentDate: new Date(), // 结束时间默认日期
            activeIndex: 0,
            navData: [
                {
                    name: '按工程类型',
                    type: 1,
                },
                {
                    name: '按区域',
                    type: 2,
                },
                {
                    name: '按开工状态',
                    type: 3,
                },
            ],
            ProjectNumberData: [],
            QuantityNumberData: [],
            statistics: {},
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.endTimeValue = this.formatDate(this.endCurrentDate);
    },
    mounted() {
        // 头部统计字段
        this.getStatistics();
        // 获取工程数量统计
        this.getProjectNumber();
        // 已用方量统计
        this.getQuantityNumber();
    },
    methods: {
        getStatistics() {
            this.$axios
                .get('/interfaceApi/report/tjfx/gcxm/gcyl/tj?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.statistics = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 工程用量-按工程类型-工程数量统计
        getProjectNumber() {
            this.$axios
                .get('/interfaceApi/report/tjfx/gcxm/gcyl/gclx/gcsl?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.ProjectNumberData = res;
                    this.myChart1();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 工程用量-按工程类型-已用方量统计
        getQuantityNumber() {
            this.$axios
                .get('/interfaceApi/report/tjfx/gcxm/gcyl/gclx/yyfl?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.QuantityNumberData = res;
                    this.myChart2();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        startConfirmData(val) {
            // this.startCurrentDate = val; // 开始时间默认日期
            // this.endCurrentDate = new Date(val.getTime() + 3600 * 1000 * 24 * 6);// 结束时间默认日期

            this.startTimePicker = false;
            this.startTimeValue = this.formatDate(val);
            // this.endTimeValue = this.formatDate(this.endCurrentDate);
            // 头部统计字段
            this.getStatistics();
            // 获取工程数量统计
            this.getProjectNumber();
            // 已用方量统计
            this.getQuantityNumber();
        },
        endConfirmData(val) {
            // this.startCurrentDate = new Date(val.getTime() - 3600 * 1000 * 24 * 6); // 开始时间默认日期
            // this.endCurrentDate = val;// 结束时间默认日期

            this.endTimePicker = false;
            this.endTimeValue = this.formatDate(val);
            // this.startTimeValue = this.formatDate(this.startCurrentDate);
            // 头部统计字段
            this.getStatistics();
            // 获取工程数量统计
            this.getProjectNumber();
            // 已用方量统计
            this.getQuantityNumber();
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        toggle(index) {
            this.activeIndex = index;
        },
        myChart1() {
            const myChart = this.$echarts.init(document.getElementById('myChart1'));
            const xdata = [];
            const data = [];

            this.ProjectNumberData.forEach(item => {
                xdata.push(item.name);
                data.push(item.value);
            });

            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(个)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: 'hill',
                    type: 'pictorialBar',
                    barCategoryGap: '0%',
                    symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#449FF3',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        padding: [0, 10, 4, 10],
                        align: 'center',
                        lineHeight: 20,
                        backgroundColor: {
                            image: bg_blue,
                            width: 38,
                        },
                    },
                    barWidth: 30,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#3e79c5', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#55a7fe', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
        myChart2() {
            const myChart = this.$echarts.init(document.getElementById('myChart2'));
            const xdata = [];
            const data = [];

            this.QuantityNumberData.forEach(item => {
                xdata.push(item.name);
                data.push(item.value);
            });

            const option = {
                grid: {
                    left: '10%',
                    top: '10%',
                    bottom: '2%',
                    right: '14%',
                },
                xAxis: {
                    type: 'value',
                    name: '(方)',
                    nameTextStyle: {
                        align: 'top',
                    },
                    scale: true,
                    position: 'top',
                    // min: 0,
                    boundaryGap: false,
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },

                },
                yAxis: {
                    type: 'category',
                    nameGap: 16,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#999',
                        },
                    },
                    data: xdata,
                },
                series: [{
                    type: 'bar',
                    stack: '',
                    // symbol: 'fixed',
                    // symbolSize: [10, 10],
                    // symbolMargin: 1,
                    // symbolRepeat: 'repeat',
                    // symbolBoundingData: 0,
                    label: {
                        show: true,
                        position: 'right',
                        distance: 5,
                        color: '#FA8B47',
                        fontSize: 12,
                        // width: 18,
                        // height: 22,
                        // align: 'center',
                        // lineHeight: 20,
                    },
                    // barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(239,171,84,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(250,139,71,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            show: false,
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .project-dose-wrappper
        width 100%
        height 100%
        background #F0F0F0
        .top-wrapper
            background #ffffff
            padding 10rpx
            .select-wrapper
                height 45rpx
                box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
                border-radius 8px
                display flex
                .select-item
                    flex 1
                    text-align center
                    span
                        font-size 14rpx
                        font-weight 600
                        line-height 45rpx
                    i
                        color #979EA7
                p
                    line-height 45rpx
                    color #979EA7
                    font-weight 600
            .statistics-head
                background #ffffff
                display flex
                padding 10rpx
                margin-top 10rpx
                div
                    flex 1
                    text-align center
                    &.month-count
                        span
                            color #FA8436
                            font-size 16rpx
                    &.year-count
                        span
                            color #5588F1
                            fonts-size 16rpx
                    p
                        font-size 10rpx
                        color #666666
                        line-height 20rpx
        .chart-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
                margin-top 15rpx
            .my-chart
                height 240rpx
        .bottom-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
                // margin-top 15rpx
            .my-chart
                height 240rpx

</style>
